/** @jsx jsx */
import { useContext } from "react"
import { Box, Grid, jsx } from "theme-ui"
import Image from "gatsby-image"
import { animated as a } from "react-spring"

import CaseBuilderFooter from "./CaseBuilderFooter"
import CaseBuilderHeader from "./CaseBuilderHeader"
import FlavorNotes from "./FlavorNotes"
import FlavorsList from "./FlavorsList"
import HowItWorks from "./HowItWorks"

import { Context } from "../../context/MainContext"

import enums from "../../util/enums"

function DesktopGrid({
  bundleSize,
  colors,
  flavors,
  backgroundImageFluid,
  index,
  isOpen,
  numItems,
  selectedVariants,
  setIndex,
  setIsOpen,
  transitions,
}) {
  const {
    store: { caseBuilderMode },
  } = useContext(Context)

  const styles = {
    container: {
      display: ["none", "none", "grid", "grid"],
      gridTemplateColumns: ["repeat(6, 1fr)", null, "repeat(12, 1fr)"],
      gridTemplateRows: "auto 1fr auto",
      position: "relative",
      width: "100%",
      height: "100%",
      color: colors.text,
    },
    image: {
      gridColumn: "1 / -1",
      gridRow: "2 / -1",
      zIndex: 0,
    },
  }

  return (
    <Grid id="desktop" gap={2} sx={styles.container}>
      {/* VIEW MODE */}
      {caseBuilderMode === enums.mode.view &&
        transitions.map(({ item, props, key }) => (
          <a.div style={props} sx={styles.image} key={key}>
            <Image
              style={{
                width: "100%",
                height: "100%",
              }}
              imgStyle={{
                backgroundColor: item.backgroundColor,
                objectFit: "cover",
                objectPosition: "50% 50%",
                height: "100%",
              }}
              fluid={item.productImage.localFile.childImageSharp.fluid}
              alt={item.title}
            />
          </a.div>
        ))}

      {/* BUNDLE MODE */}
      {caseBuilderMode === enums.mode.bundle && (
        <Box sx={styles.image}>
          <Image
            style={{
              width: "100%",
              height: "100%",
            }}
            imgStyle={{
              objectFit: "cover",
              objectPosition: "50% 50%",
              height: "100%",
            }}
            fluid={backgroundImageFluid}
            alt={"Create your bundle"}
          />
        </Box>
      )}

      {/* HEADING */}

      <CaseBuilderHeader colors={colors} />

      {/* BODY */}
      <Box
        sx={{
          gridColumn: "1 / 7",
          gridRow: 2,
          padding: "40px 0 0 20px",
          "@media screen and (max-height: 1000px)": {
            padding: "30px 0 0 20px",
          },
          "@media screen and (max-height: 800px)": {
            padding: "20px 0 0 20px",
          },
        }}
      >
        {caseBuilderMode === enums.mode.view && (
          <FlavorNotes
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            flavors={flavors}
            index={index}
          />
        )}
        {caseBuilderMode === enums.mode.bundle && (
          <HowItWorks
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            flavors={flavors}
            index={index}
          />
        )}
      </Box>

      {/* FLAVORS LIST */}
      <FlavorsList
        bundleSize={bundleSize}
        colors={colors}
        flavors={flavors}
        index={index}
        numItems={numItems}
        selectedVariants={selectedVariants}
        setIndex={setIndex}
      />

      {/* FOOTER */}
      <CaseBuilderFooter
        bundleSize={bundleSize}
        colors={colors}
        numItems={numItems}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
    </Grid>
  )
}

export default DesktopGrid
